// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NrXA8","pageTitle":"styles_pageTitle__aNZZB","cardsWrapper":"styles_cardsWrapper__PeB35"};